import DialogCom from "@/components/Dialog";
import {contexData} from "@/store";
import {Spin, Modal as PcModal} from "antd";
import {Progress, Toast, Modal} from "antd-mobile";
import {get, isArray, isEmpty} from "lodash";
import PubSub from "pubsub-js";
import {parse} from "querystring";
import React, {useCallback, useContext, useEffect, useMemo, useState} from "react";
import ReactJson from "react-json-view";
import {getQueryString, isMobile, optionDescriptionAddPosition, noTags, isWechat} from "../../utils/common";
import axios from "../../utils/selfRequest";
import {formatAnswer} from "./checkAnswer";
import "./index.less";
import CountDownButton from "./js/countdown";
import QuestionContent from "./js/questionContent";
import LimitAnswer from '../endPage/limitAnswer';
import {ExclamationCircleOutlined} from '@ant-design/icons';
import {language} from "@/utils/language";

function toastError(data) {
    try {
        if (data.code == 400001 || data.code == 400002) {
            const msg = isArray(data.msg) ? data.msg[0] : data.msg;
            console.log("isArray(data.msg)", isArray(data.msg));
            PubSub.publish("Modalalert", noTags(msg));
            return true;
        } else if (data.code == 500) {
            PubSub.publish("Modalalert", noTags(data.msg));
            return true;
        }
        const msg = data.data?.errorMessageVo?.message;
        if (msg && data.code === 20001) {
            PubSub.publish("Modalalert", noTags(msg));
            return true;
        } else {
            PubSub.publish("Modalalert", noTags(msg));
        }
    } catch (error) {
    }
}

// 问卷答题：控制答题页面切换
export default function Questionnaire({match, history}) {
    const {dispatch, setIsBack, infoContex} = useContext(contexData); //解构得到属性
    const thisTest = getQueryString("test");
    const endBack = getQueryString("endBack");
    const endbackId = getQueryString("endbackId");
    const backLast = getQueryString("backLast");
    const backlastSuveryid = getQueryString("backlastSuveryid");
    const backlastQuestionid = getQueryString("backlastQuestionid");
    const jdParams = getQueryString("jdParams");


    const [mySuveryid, setMySuveryid] = useState(match.params["id"]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dialogInfor, setDialogInfor] = useState("");


    const [surveyInfo, setSurveyInfo] = useState({alias: ""});
    const [restart, setrestart] = useState(false);
    const [sampleInfo, setSampleInfo] = useState({questionIndex: -1});
    const {questions} = sampleInfo;
    const [answers, setAnswers] = useState([]);
    const [loading, toggleLoading] = useState(true);
    let ua = navigator.userAgent.toLowerCase();
    let browserType = ua.match(/MicroMessenger/i) === "micromessenger";
    const [questionsList, setQuestionsList] = useState([]);

    // useEffect(() => {
    //   if (!isMobile) {
    //     var t = window.devicePixelRatio; // 获取下载的缩放 125% -> 1.25    150% -> 1.5
    //     document.body.style.zoom = 1 / t; // 就去修改页面的缩放比例
    //   }
    // });

    const isWeixin = () => {
        let ua = navigator.userAgent.toLowerCase()
        return ua.indexOf('micromessenger') !== -1 && ua.indexOf('wxwork') === -1
        // ua.indexOf('wxwork') === -1 这句是排除企业微信用的
    }


    useEffect(() => {
        if (endBack) {
            setMySuveryid(endbackId);
            axios.get(`answer/test/surveyInfo/${endbackId}`).then((res) => {
                const indata = res.data || {};
                setSurveyInfo(indata);

                sessionStorage.setItem("internationalizeFlag", indata.language || "zh")
                dispatch({type: "init", data: indata});
            });
            axios
                .get(`answer/test/load/${endbackId}/0`, void 0, void 0, {
                    id: undefined,
                    first: true,
                })
                .then((res) => {
                    setIsBack(false);
                    const indata = res.data || {};
                    if (indata) {
                        setSampleInfo((sampleInfo) => ({
                            ...sampleInfo,
                            ...indata,
                            questionIndex: indata.questions.length > 0 ? 0 : -1,
                        }));
                    }
                })
                .finally(() => {

                    toggleLoading(false);
                });
        } else if (backLast) {
            setMySuveryid(backlastSuveryid);
            axios.get(`answer/test/surveyInfo/${backlastSuveryid}`).then((res) => {
                const indata = res.data || {};
                setSurveyInfo(indata);

                sessionStorage.setItem("internationalizeFlag", indata.language || "zh")
                dispatch({type: "init", data: indata});
            });
            setAnswers([]);
            axios
                .get(`answer/test/back/${backlastSuveryid}`, void 0, void 0, {
                    id: backlastQuestionid,
                    endback: true,
                })
                .then((res) => {
                    console.log("=============== back");
                    setIsBack(true);
                    const indata = res.data || {};
                    indata.isBack = true;
                    setQuestionData(indata);
                    setQuestionsList(indata.questions);
                    let arr = indata.answers;
                    indata.questions.forEach((element) => {
                        if (element.model === "age") {
                            indata.answers[0].model = "age";
                            setAnswers(indata.answers);
                        } else {
                            setAnswers(arr);
                        }
                    });
                })
                .finally(() => {
                    toggleLoading(false);
                });
        } else {
            const axioshData = async () => {
                axios.get(`answer/test/surveyInfo/${mySuveryid}`).then((res) => {
                    const indata = res.data || {};
                    setSurveyInfo(indata);
                    sessionStorage.setItem("internationalizeFlag", indata.language || "zh")

                    dispatch({type: "init", data: indata});
                    if (indata?.preferences?.titleShow) {
                        document.title = indata?.preferences?.subtitle;
                    }
                });
                let wetStatus = void 0;
                if (browserType || isWeixin()) {
                    wetStatus = get(
                        await axios.get(`answer/test/invite/${mySuveryid}`),
                        "data.wetStatus",
                        null
                    );

                    wetStatus = wetStatus ? {code: getQueryString("code")} : void 0;
                }

                // 珍爱网添加参数
                if ((window.location.search || "").includes("mid")) {
                    wetStatus = {
                        param1: parse(window.location.search.replace("?", "")).mid,
                    };
                }

                if (jdParams) {
                    wetStatus = {
                        ...(wetStatus||{}),
                        jdParams: jdParams,
                    };
                }

                axios
                    .get(`answer/test/load/${mySuveryid}/0`, void 0, void 0, wetStatus)
                    .then((res) => {
                        setIsBack(false);
                        const indata = res.data || {};

                        // 配额满跳转到结束页 || 重复答题
                        if (indata.status !== 0) {
                            sessionStorage.setItem("statusMessage", res.data.statusMessage);
                            history.push(
                                `/endPage?surveryId=${mySuveryid}
              &questionId=null&test=${thisTest}`
                            );
                            return;
                        }

                        if (indata) {
                            setSampleInfo((sampleInfo) => ({
                                ...sampleInfo,
                                ...indata,
                                questionIndex: (indata.questions || []).length > 0 ? 0 : -1,
                            }));
                            setQuestionsList(indata.questions);

                            let arr = indata.answers;
                            indata.questions.forEach((element) => {
                                if (element.model == "age") {
                                    if (indata.answers.length) {
                                        indata.answers[0].model = "age";
                                    }
                                    setAnswers(indata.answers);
                                } else {
                                    setAnswers(arr);
                                }
                            });

                        }
                    })
                    .catch((res) => {
                        // 调查已经结束
                        if (res.code === 400) {
                            sessionStorage.setItem("statusMessage", res.msg);
                            history.push(
                                `/endPage?surveryId=${mySuveryid}&questionId=${sampleInfo.id}&test=${thisTest}`
                            );
                        } else if (res.code === 500) {
                            PubSub.publish("Modalalert", res.msg);
                            setrestart({})
                        }
                    })
                    .finally(() => {
                        toggleLoading(false);
                    });
            };
            axioshData();
        }
    }, [endBack, backLast]);

    useEffect(() => {
        console.log(surveyInfo);
        console.log("test-test")
        if (isMobile) {
            document.body.style.cssText = `background: url(${surveyInfo.themeMoImage}) no-repeat fixed center/100% 100% content-box; font-size: ${surveyInfo?.preferences?.h5FontSize}; `;
        } else {
            document.body.style.cssText = `background: url(${surveyInfo.themePcImage}) no-repeat fixed center/100% 100% content-box; font-size: ${surveyInfo?.preferences?.pcFontSize}; `;
        }
    }, [surveyInfo]);

    // 集中收集 事件点击 添加  全局dialog
    useEffect(() => {
        try {
            if (questions) {
                setTimeout(() => {
                    const btn2 = document.getElementsByClassName('herfaddFlag');
                    [...btn2].forEach((element, index) => {
                        element.onclick = showMsgDialog
                    });
                }, 100);
            }
        } catch (error) {
            console.error(error)
        }
    });

    // 显示  Dialog
    const showMsgDialog = useCallback((e) => {
        e.stopPropagation();
        if (questions && e.target.id) {
            let dialogDescriptionMsg
            let posttion = e.target.id.split("_");
            let findIpartIdObj = questions.find(item => item.id == posttion[0]);
            if (!findIpartIdObj) {
                findIpartIdObj = questions[0].childs.find(item => item.id == posttion[0]);
            }
            // 由于网格题目触发点无法得知
            let findchrenIDObj = (findIpartIdObj.childs || []).find(item2 => item2.id === posttion[1]) || findIpartIdObj.options.find(item2 => item2.id === posttion[1]);
            dialogDescriptionMsg = findchrenIDObj.dialogDescription;
            setDialogInfor(dialogDescriptionMsg)
            setIsModalOpen(!isModalOpen);
        }
    }, [questions]);

    // 添加城市校验
    const verificationCity = () => {
        let stop = false;
        try {
            questions.map((question) => {
                const {model, id, required, cityShowType} = question;
                if (required || answers.length) {
                    if (model === "city") {
                        const answer =
                            answers.find((a = {}) => Object.keys(a)[0] === id) || {};

                        const hasProperty = (obj = {}, property) =>
                            obj.hasOwnProperty(property);

                        if (cityShowType === 5) {
                            stop = !hasProperty(answer[id], "district");
                        }
                        if (cityShowType === 4) {
                            stop = !hasProperty(answer[id], "city");
                        }
                        if (cityShowType === 2) {
                            stop = !hasProperty(answer[id], "province");
                        }
                        if (cityShowType === 3) {
                            stop = !hasProperty(answer[id], "city");
                            if (!stop && !answer[id]["city"]["text"].includes("-1")) {
                                stop = !hasProperty(answer[id], "district");
                            }
                        }
                        if (cityShowType === 1) {
                            stop = !hasProperty(answer[id], "province");
                            if (!stop && !answer[id]["province"]["text"].includes("-1")) {
                                stop = !hasProperty(answer[id], "city");
                            }
                        }
                        if (cityShowType === 0) {
                            stop = !hasProperty(answer[id], "province");
                            if (!stop && !answer[id]["province"]["text"].includes("-1")) {
                                stop = !hasProperty(answer[id], "city");
                                if (!stop && !answer[id]["city"]["text"].includes("-1")) {
                                    stop = !hasProperty(answer[id], "district");
                                }
                            }
                        }

                        if (stop) {
                            PubSub.publish("Modalalert", language().select_region);
                        } else {
                            if (!answer[id]["city"]) {
                                answer[id]["city"] = {text: "-1:其他"};
                            }
                            if (!answer[id]["district"]) {
                                answer[id]["district"] = {text: "-1:其他"};
                            }
                        }
                    }
                }
                return undefined;
            });
        } catch (error) {
            PubSub.publish("Modalalert", language().select_region);
            return true;
        }
        return stop;
    };

    // 校验日期输入
    const verificationAge = () => {
        // 获取 具体时间
        if (
            get(questions, "length", 0) > 0 &&
            get(questions[0], "model") === "age"
        ) {
            if (answers[0]) {
                for (let [key, value] of Object.entries(answers[0])) {
                    for (let [key, value2] of Object.entries(value)) {
                        if (value2?.text) {
                            const {ageType} = questions[0];
                            let getAgeDate = value2.text.split("-");
                            if (ageType === 3) {
                                if (
                                    isEmptyTo(getAgeDate[0]) ||
                                    isEmptyTo(getAgeDate[1]) ||
                                    isEmptyTo(getAgeDate[2])
                                ) {
                                    PubSub.publish("Modalalert", language().select_time);
                                    return true;
                                }
                            } else if (ageType === 2) {
                                if (isEmptyTo(getAgeDate[0]) || isEmptyTo(getAgeDate[1])) {
                                    PubSub.publish("Modalalert", language().select_time);
                                    return true;
                                }
                            } else if (ageType === 1) {
                                if (isEmptyTo(getAgeDate[0])) {
                                    PubSub.publish("Modalalert", language().select_time);
                                    return true;
                                }
                            }
                        } else {
                            PubSub.publish("Modalalert", language().select_time);
                            return true;
                        }
                    }
                }
            } else {
                PubSub.publish("Modalalert", language().select_time);
                return true;
            }
        }
        return false;
    };

    const verificationPhone = () => {
        // 获取 具体时间
        if (
            get(questions, "length", 0) > 0 &&
            get(questions[0], "model") === "phone"
        ) {
            if (questions[0].required === 0
                && isEmptyStr(answers[0]?.[questions[0]?.id]?.phone?.text)
                && isEmptyStr(answers[0]?.[questions[0]?.id]?.verificationCode?.text)
            ) {
                return false;
            }
            if (answers[0]) {
                if (!(/^1\d{10}$/.test(answers[0]?.[questions[0]?.id]?.phone?.text || ''))) {
                    PubSub.publish("phoneFormatErr", language().phone_format_err);
                    return true;
                }
                if (questions[0].smsVerificationRequired === 1 && (answers[0]?.[questions[0]?.id]?.verificationCode?.text || '').length === 0) {
                    PubSub.publish("Modalalert", language().phone_verification_code_empty);
                    return true;
                }
                if (questions[0].smsVerificationRequired === 1 && (answers[0]?.[questions[0]?.id]?.verificationCode?.text || '').length !== 6) {
                    PubSub.publish("Modalalert", language().phone_verification_code_err);
                    return true;
                }
            } else {
                PubSub.publish("Modalalert", language().toast_msg);
                return true;
            }
        }
        return false;
    };

    // AI对话题校验：必答且对话未结束时拦截
    const verificationAiChat = () => {
        if (get(questions, "length", 0) === 0) return false;
        for (let i = 0; i < questions.length; i++) {
            const q = questions[i];
            if (q.model === "ai_chat" && q.required === 1) {
                const ans = answers[i];
                // 遍历 answer 查找含 text 的条目（避免大数字 ID 精度丢失导致 key 不匹配）
                let isFinished = false;
                if (ans) {
                    outer: for (const qKey of Object.keys(ans)) {
                        const qVal = ans[qKey];
                        if (qVal && typeof qVal === 'object') {
                            for (const oKey of Object.keys(qVal)) {
                                const oVal = qVal[oKey];
                                if (oVal && oVal.text) {
                                    try {
                                        const data = JSON.parse(oVal.text);
                                        if (data && typeof data === "object" && !Array.isArray(data)) {
                                            isFinished = !!(data.isFinished || data.completed);
                                        }
                                    } catch (e) { /* ignore */ }
                                    if (isFinished) break outer;
                                }
                            }
                        }
                    }
                }
                if (!isFinished) {
                    PubSub.publish("Modalalert", "请继续回答问题");
                    return true;
                }
            }
        }
        return false;
    };


    useEffect(() => {
        getLimitFn();


    }, [])


    useEffect(() => {

        PubSub.subscribe("Modalalert", (msg, data) => {
            if (isMobile) {
                Modal.alert('', <span dangerouslySetInnerHTML={{__html: noTags(data)}}/>, [
                    {text: language().modal_ok, onPress: () => console.log('ok')},
                ]);
            } else {
                PcModal.warning({
                    title: '',
                    icon: "",
                    content: <><ExclamationCircleOutlined style={{color: "#faad14", marginRight: 5}}/> <span
                        dangerouslySetInnerHTML={{__html: noTags(data)}}/></>,
                    okText: language().modal_ok,
                    cancelText: false,
                });
            }
        });


        return () => {
            PubSub.unsubscribe("Modalalert")
        }
    }, [])


    const [wechatLimit, setwechatLimit] = useState(0);
    const getLimitFn = async () => {
        const redData = await axios.get(`answer/test/invite/${mySuveryid}`);
        console.log(redData, 334343343443);
        if (redData?.data) {
            setwechatLimit(redData?.data?.wechatLimit);
        }
    }

    const {current, total, percent} = sampleInfo;
    const {
        preferences: {
            progress,
            lastButton = "上一页",
            nextButton = "下一页",
            submitButton = "提交",
            restartButton = '重新开始',
            end,
            limitAnswerStatus = 0,
        } = {},
    } = surveyInfo;
    console.log(surveyInfo, 34445555);

    // 同步问题数据
    const setQuestionData = (indata) => {
        indata.questions = indata.questions || [];
        setSampleInfo({...indata});
        setAnswers([]);
    };

    // 改变之页面/问题
    const changeChildren = (direction) => {
        PubSub.publish("phoneFormatErrClear");
        if ((direction === 1 || direction === 1) && verificationAge()) return;
        if (direction === 1 && verificationCity()) return;
        if (direction === 1 && verificationPhone()) return;
        // AI对话题：必答且对话未结束时拦截
        if (direction === 1 && verificationAiChat()) return;

        toggleLoading(true);

        // set submitAnswer end
        ({
            "-1": () => {
                // 回到上一题
                dispatch({
                    type: "highlight",
                    data: {highlight: ""},
                });
                setAnswers([]);
                axios
                    .get(`answer/test/back/${mySuveryid}`, void 0, void 0, {
                        id: sampleInfo.id,
                    })
                    .then((res) => {
                        console.log("----------");
                        setIsBack(true);
                        const indata = res.data || {};
                        indata.isBack = true;
                        setQuestionData(indata);
                        setQuestionsList(indata.questions);
                        let arr = indata.answers;
                        indata.questions.forEach((element) => {
                            if (element.model === "age") {
                                indata.answers[0].model = "age";
                                setAnswers(indata.answers);
                            } else {
                                setAnswers(arr);
                            }
                        });
                    })
                    .finally(() => {
                        toggleLoading(false);
                    });
            },
            0: () => {
                // 回首页
                axios
                    .get(`answer/test/load/${mySuveryid}/1`, void 0, void 0, {
                        id: undefined,
                        first: true,
                    })
                    .then((res) => {
                        setAnswers([]);
                        setIsBack(false);
                        const indata = res.data || {};
                        if (indata) {
                            dispatch({type: "highlight", data: {highlight: ""}});
                            setSampleInfo((sampleInfo) => ({
                                ...sampleInfo,
                                ...indata,
                                questionIndex: indata.questions.length > 0 ? 0 : -1,
                            }));

                            let arr = indata.answers;
                            indata.questions.forEach((element) => {
                                if (element.model == "age") {
                                    if (indata.answers.length) {
                                        indata.answers[0].model = "age";
                                    }
                                    setAnswers(indata.answers);
                                } else {
                                    setAnswers(arr);
                                }
                            });
                        }
                    })
                    .finally(() => {

                        toggleLoading(false);
                    });
            },
            1: () => {
                answers.forEach((item) => {
                    try {
                        delete item["model"];
                    } catch (error) {
                    }
                });
                let answer_post = formatAnswer(questions, answers);
                /////////////////////////////一页多题//////////////////////////
                if (JSON.stringify(answer_post[0].answers) == "{}") {
                    delete answer_post[0].answers;
                }

                axios
                    .post(
                        `answer/test/submit/${sampleInfo["suveryId"]}`,
                        answer_post,
                        "api/v1/",
                        {id: sampleInfo.id}
                    )
                    .then((res) => {
                        setAnswers([]);
                        setIsBack(false);
                        const indata = res.data || {};
                        setQuestionData(indata);
                        setQuestionsList(indata.questions);
                        let arr = indata.answers;
                        indata.questions.forEach((element) => {
                            if (element.model == "age") {
                                if (indata.answers.length) {
                                    indata.answers[0].model = "age";
                                }
                                setAnswers(indata.answers);
                            } else {
                                setAnswers(arr);
                            }
                        });

                        if (get(res, "data.status", null) !== 0) {
                            dispatch({type: "highlight", data: {highlight: ""}});
                            sessionStorage.setItem("statusMessage", res.data.statusMessage);
                            // history.push("https://baidu.com")
                            const redirectUrl =get(res, "data.redirectUrl", null)
                            if (redirectUrl){
                                window.location.href=redirectUrl
                            }else {
                                history.push(
                                    `/endPage?surveryId=${sampleInfo["suveryId"]}&questionId=${sampleInfo.id}&test=${thisTest}`
                                );
                            }
                        }
                    })
                    .catch((data) => {
                        try {
                            toastError(data);
                            const msg = data.data?.errorMessageVo?.message;
                            // When showing errorMessageVo.message, do not highlight options/background.
                            if (!msg) {
                                const {id, parentId} = data.data?.errorMessageVo?.object;
                                dispatch({type: "highlight", data: {highlight: id}});
                                if (sampleInfo.questions.length > 0) {
                                    let optionForm = get(
                                        sampleInfo,
                                        "questions[0].preferences.childPrefer.optionForm",
                                        ""
                                    );
                                    if (optionForm == 4) {
                                        let childs = get(sampleInfo, "questions[0].childs", []);
                                        let index = childs.findIndex((ele) => ele.id == id);
                                        PubSub.publish("noAnswer", index);
                                    } else {
                                        const pIndex = questionsList.findIndex((item) => {
                                            return item.id === parentId
                                        })
                                        if (pIndex < 0) return;
                                        const chIndex = questionsList[pIndex]?.childs?.findIndex((list) => {
                                            return list.id === id
                                        })
                                        if (chIndex >= 0) {
                                            infoContex.crouselRef.slickGoTo(chIndex);
                                        }
                                        // document.getElementById(id) &&
                                        //   document.getElementById(id).scrollIntoView({
                                        //     behavior: "instant",
                                        //     block: "nearest",
                                        //     inline: "nearest",
                                        //   });
                                    }
                                }
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    })
                    .finally(() => {
                        toggleLoading(false);
                    });
            },
        }[direction]());
    };

    const showPercent = Math.floor((current / total) * 100);

    const countdown = useMemo(() => {
        const sum = (questions || []).reduce((pre, item) => {
            return pre + (item.preferences.countdown || 0);
        }, 0);
        return sum;
    }, [questions]);
    const getLimitAnswerStatus = () => {
        // 只能在pc端打开
        if (limitAnswerStatus == 1 && isMobile) return true;
        // 只能在移动端打开
        if (limitAnswerStatus == 2 && !isMobile) return true;
        return false;
    }
    if (wechatLimit == 1 && !isWechat()) {
        return <LimitAnswer showStr={language().end_wx} surveyInfo={surveyInfo}/>
    }
    if (getLimitAnswerStatus()) {
        return <LimitAnswer surveyInfo={surveyInfo}
                            showStr={limitAnswerStatus == 1 ? language().end_pc : language().end_phon}/>
    }
    return (
        <div
            className="layout"
            style={{
                backgroundColor: surveyInfo.backColor || "#e4ebff",
                margin: "15px",
            }}
        >

            {isModalOpen && <DialogCom dialogMsg={dialogInfor} cb={() => {
                setIsModalOpen(!isModalOpen);
            }}></DialogCom>}

            {localStorage.debug && (
                <ReactJson
                    src={answers}
                    name="answers"
                    collapsed={localStorage.collapsed}
                />
            )}
            <div className="layout-header">
                <div
                    className="survey-title"
                    // style={{ color: surveyInfo.themeColor }}
                    title={
                        getQueryVariable("QTP")
                            ? JSON.stringify(questions)
                            : surveyInfo.alias || ""
                    }
                >
                    {surveyInfo.alias || ""}
                </div>
                {+percent !== 100 && (
                    <div className="show-info">
                        {+progress === 1 && (
                            <div style={{display: "flex", flex: 1, justifyContent: "center", alignItems: 'center'}}>
                                <div className="progress" style={{display: "flex", flex: 1}}>
                                    <Progress percent={showPercent} position="normal"/>
                                </div>
                                <p aria-hidden="true">{showPercent}%</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {+percent === 100 ? (
                <div
                    style={{textAlign: "center"}}
                    dangerouslySetInnerHTML={{
                        __html: end
                            .replace(/<p><\/p>/g, "<br />")
                            .replace(/\n\n/g, "<br />")
                            .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                    }}
                />
            ) : (
                <Spin spinning={loading}>
                    <div className="layout-body">
                        <div className="question-content">
                            {get(questions, "length", 0) ? (
                                optionDescriptionAddPosition(questions).map((info, index) => {

                                    ///////////////////////////////找到入口1
                                    info.isBack = sampleInfo?.isBack;
                                    return (
                                        <>
                                            {/* {isModalOpen && <AddClickPopup options={info.options} cb={() => {
                        setIsModalOpen(!isModalOpen);
                      }} />} */}


                                            <QuestionContent
                                                key={info.id}
                                                info={info}
                                                themeColor={surveyInfo.themeColor || "#3c8dff"}
                                                themeId={surveyInfo.themeId}
                                                answer={answers[index] || {}}
                                                surveyId={sampleInfo["suveryId"]}
                                                sampleId={sampleInfo.id}
                                                changeAnswer={(value, agedate) => {
                                                    if (agedate) {
                                                        info.agedate = agedate;
                                                    }
                                                    if (value && Object.keys(value).length === 0) {
                                                        setAnswers((oldAnswer) => {
                                                            const newAnswer = [...oldAnswer];
                                                            delete newAnswer[index];
                                                            return newAnswer;
                                                        });
                                                    } else {
                                                        setAnswers((oldAnswer) => {
                                                            const newAnswer = [...oldAnswer];
                                                            if (value) {
                                                                newAnswer[index] = {[info.id]: value};
                                                            } else {
                                                                delete newAnswer[index];
                                                            }
                                                            return newAnswer;
                                                        });
                                                    }
                                                }}
                                            />
                                        </>

                                    );
                                })
                            ) : restart ? null : (
                                <div style={{textAlign: "center"}}>
                                    {language().end_no_answer}
                                </div>
                            )}
                        </div>
                        {
                            !getLimitAnswerStatus() && questions?.length && (
                                <div className="page-buttons">
                                    {!!(questions?.length) && <CountDownButton
                                        className="page-button"
                                        themeColor={surveyInfo.themeColor || "#3c8dff"}
                                        countdown={countdown}
                                        onClick={() => {
                                            changeChildren(1);
                                        }}
                                        questions={questions}
                                        btnText={
                                            showPercent === 100
                                                ? submitButton || "提交"
                                                : nextButton || "下一页"
                                        }
                                    />}

                                    {((!!getQueryString("test") && sampleInfo["current"] > 1) ||
                                        (!!getQueryString("endBack") && sampleInfo["current"] > 1) ||
                                        (!!getQueryString("backLast") &&
                                            sampleInfo["current"] > 1)) && (
                                        <div
                                            className="page-button"
                                            style={{
                                                backgroundColor: surveyInfo.themeColor || "#3c8dff",
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: (lastButton || "上一页")
                                                    .replace(/<p><\/p>/g, "<br />")
                                                    .replace(/\n\n/g, "<br />")
                                                    .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                                            }}
                                            onClick={() => {
                                                changeChildren(-1);
                                            }}
                                        />
                                    )}
                                    {(!!getQueryString("test") ||
                                        !!getQueryString("endBack") ||
                                        !!getQueryString("backLast")) && (
                                        <div
                                            className="page-button"
                                            style={{
                                                backgroundColor: surveyInfo.themeColor || "#3c8dff",
                                            }}
                                            onClick={() => {
                                                setSampleInfo({
                                                    questionIndex: -1,
                                                    questions: [],
                                                });
                                                setrestart(true);
                                                changeChildren(0);
                                            }}
                                        >
                                            {restartButton}
                                        </div>
                                    )}
                                </div>
                            )
                        }

                    </div>
                </Spin>
            )}

        </div>
    );
}

function isEmptyTo(v) {
    if (isEmpty(v) || v == "undefined") {
        return true;
    } else {
        return false;
    }
}

function isEmptyStr(s) {
    if (s == undefined || s === '') {
        return true
    }
    return false
}


function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return false;
}
